module.exports = require('./helpers/bundle-url').getBundleURL('1EpzM') + "Name.99bd89fe.glb" + "?" + Date.now();